import { RestAPI as API } from "@aws-amplify/api-rest";
import React from "react";
import TableComponent from "./common/TableComponent";

import { AppLayout, Button, SplitPanel } from "@cloudscape-design/components";
import DetailsComponent from "./common/DetailsComponent";
import { AdversaryModel } from "./models/AdversaryModel";
import { SPLIT_PANEL_I18NSTRINGS } from "./common/AriaConstants";
import { appLayoutLabels } from "./common/AriaConstants";
import NavComponent from "./common/Navigation";

export default class AdversaryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adversaries: null,
      selected: null,
      selectedItem: { name: "" },
      detailsOpen: false,
      navOpen: false,
    };
    // const [toolsOpen, setToolsOpen] = useState(false);
  }
  fetchAdversary() {
    if (!this.state.adversaries) {
      API.get("API", "/adversaries").then((adversary) =>
        this.setState({ adversaries: adversary })
      );
    }
  }
  async componentDidMount() {
    this.fetchAdversary();
  }

  adversary_divs() {
    return this.state.adversaries.map((a) => <div key={a.name}>{a.name}</div>);
  }

  changeState = (event) => this.setState({ selected: event });

  setToolsOpen = (event) => this.setState({ toolsOpen: event });

  tableItemSelected = (event) => {
    this.setState({ selectedItem: event[0], detailsOpen: true });
  };
  adversarySave(data) {
    console.log(data);
    API.post("API", "/adversaries", { body: data }).then((response) =>
      // this.setState({ adversary: adversary })
      console.log("api saved: " + response)
    );
    let newAdversary = this.state.adversaries.map((item) =>
      item.name == data.name ? data : item
    );
    this.setState({ adversaries: newAdversary });
    console.log("Save State Called");
  }
  addNew = () => {
    this.setState({ selectedItem: {}, detailsOpen: true });
  };
  render() {
    if (!this.state.adversaries) return "Loading";
    return (
      <AppLayout
        contentType="table"
        content={
          <div>
            <TableComponent
              model={AdversaryModel}
              data={this.state.adversaries}
              itemSelected={this.tableItemSelected}
              title="Adversaries"
            ></TableComponent>
            <Button variant="primary" onClick={() => this.addNew()}>
              Add New
            </Button>
          </div>
        }
        toolsHide={true}
        navigationOpen={this.state.navOpen}
        onNavigationChange={({ detail }) =>
          this.setState({ navOpen: detail.open })
        }
        navigation={<NavComponent href="/" />}
        // navigationHide={true} //This is the left side pane probably want this later down the road
        splitPanelOpen={this.state.detailsOpen}
        onSplitPanelToggle={(event) =>
          this.setState({ detailsOpen: event.open })
        }
        splitPanel={
          <SplitPanel header="Details" i18nStrings={SPLIT_PANEL_I18NSTRINGS}>
            <DetailsComponent
              model={AdversaryModel}
              data={this.state.selectedItem}
              submitCallback={(data) => this.adversarySave(data)}
            />
          </SplitPanel>
        }
        ariaLabels={appLayoutLabels}
      ></AppLayout>
    );
  }
}
